import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';
import PostView from './postPage'; 
import { Main } from './homePage';
import Unsubscribe from './unsubscribe';




class App extends Component {

  

  
  
render(){

  

  
 

  return(

    <Router>

      <div className="App">

        <Switch>
          <Route exact path='/'>
            <Main />
          </Route>
          <Route exact path='/blog/:slug' render={(props) => <PostView {...props}/>}>
            
          </Route>
          <Route exact path='/unsubscribe'>
            <Unsubscribe />
          </Route>
        </Switch>
      
      
      
    
    

     
      </div> 
      
    </Router>  
  

  

   
      
    );
    
    
        }
      }

      export default App; 
